import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-left-site',
  templateUrl: './left-site.component.html',
  styleUrls: ['./left-site.component.css']
})
export class LeftSiteComponent implements OnInit {
  @Input() view: string;
  @Output() emitFilterSidebar: EventEmitter<any> = new EventEmitter<any>();
  public currentItem: string;

  constructor(
    public route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      console.log(params);
      this.currentItem = params['name'];
    });
  }

  onFilter(type: string): void {
    this.emitFilterSidebar.emit(type);
  }
}
